/**
 * Valeurs réservées des filtres de liste (migration 0133) — aucun id generique_data
 * ne vaut 0, la SP interprète 0 comme « IS NULL ».
 */
export const SANS_FAMILLE   = 0;   // famille_id   = 0 → articles sans famille
export const SANS_CATEGORIE = 0;   // categorie_id = 0 → tiers sans catégorie
export const SANS_FOURNISSEUR = 0; // fournisseur_id = 0 → articles sans fournisseur (0143)
